import { Row, Col, Form, Checkbox, Input } from "antd";
import { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_screenpw_form } from "../../actions/form_slice";
import { debounce } from "lodash";

const ScreenNamePW = forwardRef(({ onValuesChange }, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getFieldsError: form.getFieldsError,
    validateFields: form.validateFields,
    resetFields: form.resetFields,
    setFieldsValue: form.setFieldsValue,
    submit: form.submit,
    getFieldsValue: form.getFieldsValue,
  }));

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.form.screennamepw_form_type);

  const handleFormChange = debounce((changedValues) => {
    dispatch(update_screenpw_form(changedValues));
    onValuesChange(formData);
  }, 300);
  return (
    <Form
      form={form}
      onValuesChange={handleFormChange}
      // onFinish={props.onFinish}
      labelAlign="justify"
      layout="vertical"
      labelWrap
      wrapperCol={{
        flex: 1,
      }}
    >
      <Row>
        <label>Request to withdraw application. Programs withdrawn:</label>
      </Row>

      <Row gutter={2}>
        <Col span={8}>
          <Form.Item
            valuePropName="checked"
            name="Request to withdraw application. Programs withdrawn - FA"
          >
            <Checkbox value="Request to withdraw application. Programs withdrawn - FA">
              FA
            </Checkbox>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            valuePropName="checked"
            name="Request to withdraw application. Programs withdrawn - TANF"
          >
            <Checkbox value="Request to withdraw application. Programs withdrawn - TANF">
              TANF
            </Checkbox>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            valuePropName="checked"
            name="Request to withdraw application. Programs withdrawn - CC"
          >
            <Checkbox value="Request to withdraw application. Programs withdrawn - CC">
              CC
            </Checkbox>
          </Form.Item>
        </Col>
        <Form.Item name="Comments" label="Comments">
          <Input style={{ width: "100%" }} />
        </Form.Item>
      </Row>
    </Form>
  );
});
export default ScreenNamePW;
